import axios from 'axios';
import Config from '../config/environments';

export const isStrapiUrl = (url) => {
  if (!url) return false;
  
  return (
    url.includes('/content/') || 
    url.includes('/api/alerts') ||
    url.includes('localhost:1337')
  );
};

export const createSafeStrapi = () => {
  const strapiAxios = axios.create({
    baseURL: Config.END_POINT,
    timeout: 10000,
    headers: {
      'Content-Type': 'application/json'
    }
  });

  strapiAxios.interceptors.response.use(
    (response) => response,
    (error) => {
      console.warn('Erro na requisição do Strapi:', error.message || 'Erro desconhecido');
      
      return Promise.resolve({
        data: { data: null },
        status: 200,
        statusText: 'OK',
        headers: {},
        config: error.config,
        isStrapiErrorHandled: true
      });
    }
  );

  return strapiAxios;
};

export const getStrapiDataSafe = async (url, options = {}) => {
  const strapiAxios = createSafeStrapi();
  
  try {
    const response = await strapiAxios.get(url, options);
    return { data: response.data, error: null };
  } catch (error) {
    console.error('Erro inesperado ao acessar Strapi:', error);
    return { data: null, error: null };
  }
};